import React from 'react';
import { CheckIcon } from 'lucide-react';

// Barra informativa: niente conto alla rovescia finto, solo informazioni vere sull'offerta.
const ITEMS = ['Accesso immediato via e-mail', 'Pagamento unico', 'Garanzia di 7 giorni'];
export function CountdownBar() {
  return <div className="sticky top-0 z-50 w-full border-b border-white/10 bg-slate-900 text-stone-50" data-id="element-59" data-mp="2vcpbx04qu40c">
      <div className="mx-auto flex max-w-6xl items-center justify-center gap-x-4 overflow-hidden whitespace-nowrap px-4 py-2.5 text-xs sm:gap-x-6 sm:text-sm" data-id="element-60" data-mp="2rbnjb25c0q7c">
        {ITEMS.map((item, index) => <span key={item} className={`items-center gap-1.5 text-stone-50/85 ${index === 2 ? 'hidden sm:flex' : 'flex'}`} data-id="element-61" data-mp="2hhdicw2bqjl0" data-mpi={index}>
            <CheckIcon className="h-3.5 w-3.5 text-red-300" aria-hidden="true" data-id="element-62" data-mp="28evtsaz75euu" />
            {item}
          </span>)}
      </div>
    </div>;
}